module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"mapVersionsModal\" style=\"display: none;\" class=\"map-versions-bottom-section forceNotToShrink\" title=\"Map App Instance Versions\">\r\n    <div class=\"row map-versions-bottom-section\" style=\"padding-left: 0;\">\r\n        <div class=\"col-md-12\">\r\n            <table id=\"propMapFormVersionsTable\"></table>\r\n        </div>\r\n    </div>\r\n    <div class=\"row map-versions-bottom-section\" style=\"padding-left: 0;\">\r\n        <div class=\"col-md-12\" style=\"padding-right: 0;\">\r\n            <button id='btnSetAllToLatest' class=\"btn btn-default hvr-glow\">Set All to Latest</button>\r\n            <button id='btnClearAll' class=\"btn btn-default hvr-glow\">Clear All</button>\r\n        </div>\r\n    </div>\r\n    <div id=\"confirmPanel\" style=\"padding-left: 0;\">\r\n        <div class=\"row map-versions-bottom-section\">\r\n            <div class=\"col-md-12\" style=\"padding: 0;\">\r\n                <b>Warning:</b> Version mapping may cause some field data to become unavailable.\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}